<template>
  <scroll-bar v-if="useCompactSidebar" class="compact-sidebar">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
  <div v-else class="dual-sidebar">
    <scroll-bar class="primary-scroll">
      <el-menu
        class="primary-menu"
        mode="vertical"
        :default-active="activeRootPath"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF">
        <el-menu-item
          v-for="item in visibleRoutes"
          :key="item.name || item.path"
          :index="item.path"
          :class="{'is-active': item.path === activeRootPath}"
          @click="handlePrimaryClick(item)">
          <svg-icon v-if="getRouteMeta(item).icon" :icon-class="getRouteMeta(item).icon"></svg-icon>
          <span slot="title">{{getRouteMeta(item).title}}</span>
        </el-menu-item>
      </el-menu>
    </scroll-bar>
    <scroll-bar class="secondary-scroll">
      <div v-if="activeRoute" class="secondary-title">{{getRouteMeta(activeRoute).title}}</div>
      <el-menu
        v-if="activeRoute"
        :key="activeRoute.path"
        class="secondary-menu"
        mode="vertical"
        :default-active="$route.path"
        background-color="#1f2d3d"
        text-color="#bfcbd9"
        active-text-color="#409EFF">
        <template v-for="child in activeRoute.children" v-if="!child.hidden">
          <a v-if="child.path.startsWith('http')" :key="child.name" :href="child.path" target="_blank">
            <el-menu-item :index="child.path">
              <svg-icon v-if="child.meta && child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta && child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </a>
          <router-link v-else :key="child.name" :to="resolvePath(activeRoute.path, child.path)">
            <el-menu-item :index="resolvePath(activeRoute.path, child.path)">
              <svg-icon v-if="child.meta && child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta && child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-menu>
    </scroll-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  data() {
    return {
      selectedRootPath: null
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    visibleRoutes() {
      return this.routes.filter(item => !item.hidden && item.children && item.children.some(child => !child.hidden))
    },
    activeRootPath() {
      return this.selectedRootPath || (this.visibleRoutes[0] && this.visibleRoutes[0].path)
    },
    activeRoute() {
      return this.visibleRoutes.find(item => item.path === this.activeRootPath) || this.visibleRoutes[0]
    },
    isCollapse() {
      return this.$store.state.app.device === 'mobile' && !this.sidebar.opened
    },
    useCompactSidebar() {
      return this.isCollapse || this.$store.state.app.device === 'mobile'
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.syncActiveRoot()
      }
    },
    routes() {
      this.syncActiveRoot()
    }
  },
  methods: {
    syncActiveRoot() {
      const currentPath = this.$route.path
      const route = this.visibleRoutes.find(item => currentPath === item.path || currentPath.indexOf(item.path + '/') === 0)
      if (route) {
        this.selectedRootPath = route.path
      }
    },
    getRouteMeta(route) {
      if (route.meta && route.meta.title) {
        return route.meta
      }
      const child = route.children.find(item => !item.hidden)
      return (child && child.meta) || {}
    },
    handlePrimaryClick(route) {
      this.selectedRootPath = route.path
      const children = route.children.filter(item => !item.hidden)
      if (children.length === 1 && !route.alwaysShow && !children[0].children) {
        this.$router.push(this.resolvePath(route.path, children[0].path))
      }
    },
    resolvePath(parentPath, childPath) {
      return parentPath.replace(/\/$/, '') + '/' + childPath.replace(/^\//, '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue